// Components
import { Button, Checkbox, Input } from "components"

// Types
import type { Filter } from "../types"
import { FilterColumn } from "../../components"

export function FilterSection(params: Filter): JSX.Element {
  // Vars
  const filter = params.filter

  return (
    <div className="lg:flex lg:justify-between items-end">
      <div className="lg:flex items-end gap-3">
        <Input
          label="SEARCH"
          className="lg:w-[300px] md:w-full"
          placeholder="Search data..."
          onChange={res => params.handleSearch(res.target.value)}
        />

        <FilterColumn dataFilter={params.tableActive!} setTableActive={params.setTableActive!} />
        
        <div className="flex items-center gap-3 lg:mb-3 mt-3">
          <Checkbox
            value={filter.buy}
            onClick={() => params.handleCheckbox("buy")}
          >
            BUY
          </Checkbox>

          <Checkbox
            value={filter.inventory}
            onClick={() => params.handleCheckbox("inventory")}
          >
            INVENTORY
          </Checkbox>

          <Checkbox
            childrenClass="whitespace-nowrap"
            value={filter.isBuild}
            onClick={() => params.handleCheckbox("isBuild")}
          >
            IS BUILD
          </Checkbox>
        </div>
      </div>

      <div className="lg:flex lg:items-end">
        <div className="w-full">
          <Button
            className="uppercase sm:rounded-lg border-white hover:border-primary hover:bg-primary hover:text-black mb-2 w-full"
            onClick={params.reset}
          >
            Lastest Item
          </Button>
        </div>
      </div>
    </div>
  )
}